module.exports = __webpack_public_path__ + "static/media/studio_construction_telehandler_mt_735_manitou_003.3ea8b1fd.png";